function CarlaoAnalyticsIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      {/* Linha de tendência (zigzag de analytics) */}
      <path d="M3 17.5L8.5 11L12.5 14L17 8.5L21 12V13.5L17 10L12.5 15.5L8.5 12.5L3 19V17.5Z" />
      {/* Pontos nos vértices da linha */}
      <circle cx="8.5" cy="11" r="1.6" />
      <circle cx="12.5" cy="14" r="1.6" />
      <circle cx="17" cy="8.5" r="1.6" />
      {/* Eixo X (base do gráfico) */}
      <rect x="2" y="20.5" width="20" height="1.5" rx="0.7" />
      {/* Barras menores no topo — sugerem "AI sparkles" sobre o gráfico */}
      <rect x="3" y="3" width="2.5" height="3" rx="0.5" opacity="0.4" />
      <rect x="7" y="2" width="2.5" height="4" rx="0.5" opacity="0.6" />
      <rect x="11" y="3.5" width="2.5" height="2.5" rx="0.5" opacity="0.8" />
    </svg>
  );
}

export default CarlaoAnalyticsIcon;
